var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoliciesSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1899",
    "data-name": "Group 1899",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.121,
    height: 35.241,
    viewBox: "0 0 27.121 35.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48301",
    "data-name": "Path 48301",
    d: "M1271.688,657.368h-9.233a2.006,2.006,0,0,1-2-2V630.579a1.992,1.992,0,0,1,.587-1.417l3.575-3.575a1.992,1.992,0,0,1,1.417-.587h16.228a2.006,2.006,0,0,1,2,2v14.1a.637.637,0,0,1-1.274,0V627a.731.731,0,0,0-.73-.73H1266.03a.726.726,0,0,0-.516.214l-3.575,3.575a.725.725,0,0,0-.214.516v24.786a.731.731,0,0,0,.73.73h9.233a.637.637,0,0,1,0,1.274Z",
    transform: "translate(-1260.451 -625)",
    fill: "#6e6e6e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48302",
    "data-name": "Path 48302",
    d: "M1425.026,810.186h-3.48a.637.637,0,1,1,0-1.274h3.48a.637.637,0,0,1,0,1.274Z",
    transform: "translate(-1409.196 -795.487)",
    fill: "#6e6e6e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48303",
    "data-name": "Path 48303",
    d: "M1269.077,630.952h-3.8a.637.637,0,0,1,0-1.274h3.748v-3.715a.637.637,0,1,1,1.274,0v3.772A1.219,1.219,0,0,1,1269.077,630.952Z",
    transform: "translate(-1264.33 -625.302)",
    fill: "#6e6e6e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48304",
    "data-name": "Path 48304",
    d: "M1327.569,733.729h-15.024a.637.637,0,1,1,0-1.274h15.024a.637.637,0,1,1,0,1.274Z",
    transform: "translate(-1308.152 -724.611)",
    fill: "#6e6e6e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48305",
    "data-name": "Path 48305",
    d: "M1318.035,810.186h-5.49a.637.637,0,1,1,0-1.274h5.49a.637.637,0,0,1,0,1.274Z",
    transform: "translate(-1308.152 -795.487)",
    fill: "#6e6e6e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48306",
    "data-name": "Path 48306",
    d: "M1327.569,771.958h-15.024a.637.637,0,1,1,0-1.274h15.024a.637.637,0,1,1,0,1.274Z",
    transform: "translate(-1308.152 -760.049)",
    fill: "#6e6e6e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48307",
    "data-name": "Path 48307",
    d: "M1478.8,945.233h0a.636.636,0,0,1-.45-.187l-2.495-2.494a.637.637,0,0,1,.9-.9l2.044,2.044,3.627-3.627a.637.637,0,0,1,.9.9l-4.077,4.077A.636.636,0,0,1,1478.8,945.233Z",
    transform: "translate(-1459.958 -916.896)",
    fill: "#6e6e6e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48308",
    "data-name": "Path 48308",
    d: "M1428.613,863.422a.637.637,0,0,1-.351-.1l-.711-.469c-.361-.238-3.561-2.352-4.661-3.164a5.3,5.3,0,0,1-1.982-4.3v-7.577a.637.637,0,0,1,.637-.637c2.955,0,6.64-2.827,6.677-2.855a.636.636,0,0,1,.78,0h0c.037.028,3.723,2.855,6.678,2.855a.637.637,0,0,1,.637.637v7.577a5.3,5.3,0,0,1-1.982,4.3c-1.1.814-4.3,2.926-4.662,3.164l-.71.468A.636.636,0,0,1,1428.613,863.422Zm-6.431-15.013v6.973a4.031,4.031,0,0,0,1.466,3.277c1.073.793,4.246,2.888,4.6,3.125l.361.238.359-.237c.358-.236,3.531-2.331,4.606-3.126a4.031,4.031,0,0,0,1.465-3.277V848.41a9.089,9.089,0,0,1-2.031-.468,15.587,15.587,0,0,1-2.377-1.071,21.013,21.013,0,0,1-2.023-1.263,21.139,21.139,0,0,1-2.023,1.263,15.565,15.565,0,0,1-2.378,1.071A9.084,9.084,0,0,1,1422.182,848.41Zm6.431-3.592h0Z",
    transform: "translate(-1409.196 -828.181)",
    fill: "#6e6e6e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliciesSold);
export default __webpack_public_path__ + "static/media/Policies-sold.066f7ba0c7f4befda9111c897c793981.svg";
export { ForwardRef as ReactComponent };